import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=2936e66a&scoped=true"
import script from "./UserAccount.vue?vue&type=script&lang=ts"
export * from "./UserAccount.vue?vue&type=script&lang=ts"
import style0 from "./UserAccount.vue?vue&type=style&index=0&id=2936e66a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936e66a",
  null
  
)

export default component.exports